import { render, staticRenderFns } from "./WorkStateSwitch.vue?vue&type=template&id=986fb78a&scoped=true"
import script from "./WorkStateSwitch.vue?vue&type=script&lang=js"
export * from "./WorkStateSwitch.vue?vue&type=script&lang=js"
import style0 from "./WorkStateSwitch.vue?vue&type=style&index=0&id=986fb78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986fb78a",
  null
  
)

export default component.exports